import {CacheItem} from "./CacheItem";
import {HttpClient} from "@angular/common/http";
import {Observable, of, switchMap} from "rxjs";
import {lastMap} from "../../rxjs/lastMap";
import {Progress} from "./progress";
import {Log, LogTag} from "../Log";
import {DS_API_URL} from "../../constants";
import {CachingService} from "./caching.service";


export class CacheDrive extends CacheItem {
  token;
  id;

  constructor(cachingService: CachingService, httpClient: HttpClient, token: string, id: string, folder: string) {
    const url = DS_API_URL + "GoogleAjaxFileLink/" + token + '/' + id;
    super(cachingService, httpClient, url, folder, null);
    this.token = token;
    this.id = id;
  }

    protected override fetchCache(url: string, folder: string): Observable<any> {
        return this.httpClient.post(this.url, {}, {headers: null, responseType: 'text'}).pipe(
            switchMap(driveRes => {
                const driveData = JSON.parse(driveRes);
                const accessToken = driveData.accessToken;
                const options = {headers: {'Authorization': "Bearer " + accessToken}};
                return new Observable(sub => {
                    fetch(driveData.url, options).then(async function (response) {
                        debugger;
                        if (response.status == 200) {
                            const clonedResponse = response.clone();
                            caches.open(folder).then(cache => {
                                debugger;
                                cache.put(url, clonedResponse).then(a => {
                                    debugger
                                    console.log('put file completed')
                                    sub.next(url);
                                    sub.complete();
                                })
                            })
                        }
                    }).catch(error => {
                        debugger;
                        const msg = (navigator.onLine) ? "cors" : "offline"
                        sub.error({code: msg, url: url, message: "fetch fail"});
                    })
                })
            })
        );

    }

  getBody(response: Response): Promise<any> {
    return response.blob();
  }

  getData(body): any {
    return this.url;
  }
}
